import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select'];

  linkNewBrowser() {
    if (this.selectTarget.value !== '') {
      window.open(this.selectTarget.value);
    }
  }
}
